import { ResultIcon } from "@mirage/search/SearchResults";
import classNames from "classnames";
import { useMemo } from "react";
import { ChatSourceMirageSearchResult } from "../Chat/types";
import { useMultimediaPreview } from "../SearchPage/Multimedia/hooks/useMultimediaPreview";
import styles from "./ShoppingCartItemTiles.module.css";
import { getRotation } from "./resultsShoppingCartUtils";

type ShoppingCartItemTilesProps = {
  cartItems: Set<ChatSourceMirageSearchResult>;
};

export const ShoppingCartItemTiles: React.FC<ShoppingCartItemTilesProps> = ({
  cartItems,
}) => {
  const cartItemsArray = useMemo(
    () => Array.from(cartItems.values()),
    [cartItems],
  );

  return (
    <div className={styles.shoppingCartItemContainer}>
      {cartItemsArray.slice(-5).map((cartItem, index) => (
        <div
          className={classNames(styles.shoppingCartItemTile, {
            [styles.shoppingCartItemTileShadow]: index > 3,
            [styles.shoppingCartItemTilePadding]:
              !!cartItem.searchResult.previewUrl,
          })}
          style={{ rotate: `${getRotation(index)}deg` }}
          key={`${cartItem.searchResult.uuid}-shopping-cart-item`}
        >
          {cartItem.searchResult.previewUrl ? (
            <ShoppingCartItemTile
              previewUrl={cartItem.searchResult.previewUrl ?? undefined}
              title={cartItem.searchResult.title}
            />
          ) : (
            <ResultIcon result={cartItem.searchResult} size="2xlarge" />
          )}
        </div>
      ))}
    </div>
  );
};

type ShoppingCartItemTileProps = {
  previewUrl?: string;
  title: string;
};

const ShoppingCartItemTile = ({
  previewUrl,
  title,
}: ShoppingCartItemTileProps) => {
  const { base64Image, base64Loading, hasError } = useMultimediaPreview(
    previewUrl,
    512,
  );
  const thumbnailUrl =
    previewUrl ||
    (base64Image && !base64Loading && !hasError ? base64Image : undefined);
  return (
    <img
      className={styles.shoppingCartItemTileImg}
      src={thumbnailUrl}
      alt={title}
    />
  );
};
